import React, { ComponentProps } from 'react';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { PageMembershipMatchingRuleSettingsEditView } from './views/PageMembershipMatchingRuleSettingsEditView';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { PageMembershipMatchingRuleSettingsDefaultView } from './views/PageMembershipMatchingRuleSettingsDefaultView';
import { PageMembershipMatchingRuleSettingsEditBar } from './partials/PageMembershipMatchingRuleSettingsEditBar';

type PageMembershipMatchingRuleSettingsProps =
  Views<DefaultView<PageMembershipMatchingRuleSettingsDefaultView> &
  EditView<PageMembershipMatchingRuleSettingsEditView>>;

function PageMembershipMatchingRuleSettings(props: PageMembershipMatchingRuleSettingsProps) {
  const { active } = useAppContext().editModeInfo;
  return (
    <>
      {active
        ? <PageMembershipMatchingRuleSettingsEditBar {...props.views.edit} />
        : null}
      <PageMembershipMatchingRuleSettingsDefaultView {...props.views.default} />
    </>);
}

export const PageMembershipMatchingRuleSettingsBlock =
  asFetchableBlock(PageMembershipMatchingRuleSettings, BlockType.pagemembershipmatchingrulesettings);
export type PageMembershipMatchingRuleSettingsBlock = ComponentProps<typeof PageMembershipMatchingRuleSettingsBlock>;
